// extracted by mini-css-extract-plugin
export default {"main_div":"formModal_main_div__6RdmG","error_msg":"formModal_error_msg__JZ9gP"};